<script lang="ts">

  import { cn } from "$lib/utils"
  import type { Component } from "svelte"

  type Props = {
    prefix: string
    path: string
    label: string
    icon: Component
    compact?: boolean
  }

  let { prefix, path, label, icon: Icon, compact = true }: Props = $props()

</script>

<div class="flex flex-col items-center justify-self-center">
  <a
    href={`/${prefix}/${path}`}
    class="mb-1 flex size-10 items-center justify-center rounded-sm bg-muted">
    <Icon class="size-6"/>
  </a>
  <div class={cn("text-center text-xs text-gray-600", compact && "leading-none")}>
    {label}
  </div>
</div>
